import React from "react";
import { defineMessages } from "react-intl";
import "../../../api/types.js";
import "immer";
import "moment-timezone";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../../components/autocomplete/Autocomplete.styles.js";
import "../../../components/autocomplete/Autocomplete.localize.js";
import "@mui/material";
import { TreeAutocomplete } from "../../../components/autocomplete/TreeAutocomplete.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "../../../components/autocomplete/AutocompleteInfoMessage.js";
import "@mui/material/CircularProgress";
import "@mui/material/TextField";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import { Autocomplete } from "../../../components/autocomplete/Autocomplete.js";
import { InlineAutocomplete } from "../../../components/autocomplete/InlineAutocomplete.js";
import "../../../components/autocomplete/AutocompleteButton.js";
import "fast-deep-equal/es6";
import "typesafe-actions";
import { extendedViewCleanDelay } from "../../../redux-folder/view/types.js";
import "redux-observable";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "normalizr";
import "../../../redux-folder/entity/EntityProvider.js";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import "react-redux";
import "react-router";
import { getNonEmptyValueValidator } from "../../../redux-folder/view/utils.js";
import { useAgentProfiles, useAgentAutocompleteOptions } from "../hooks.js";
const localized = defineMessages({
  agentAutocompletePlaceholder: {
    id: "AgentAutocomplete_agentAutocompletePlaceholder",
    defaultMessage: "Search agent"
  },
  agentAutocompleteEmptyPlaceholder: {
    id: "AgentAutocomplete_agentAutocompleteEmptyPlaceholder",
    defaultMessage: "Enter the agent name and select the downline type"
  }
});
function AgentAutocomplete({
  viewType: containerViewType,
  defaultPlayerId,
  value,
  onChange,
  onInputChange,
  mode = "default",
  listContainerClassName,
  onlyMasterAgents,
  agentProfileEntity,
  searchBy = "username"
}) {
  const viewTypeInner = "AgentAutocomplete";
  const viewType = `${containerViewType}.${viewTypeInner}`;
  const isTreeMode = mode === "tree";
  const { items: agentProfiles, handleFilterChange } = useAgentProfiles({
    viewType,
    agentProfileEntity,
    fields: isTreeMode ? ["uid", "username", "referral.inviting_user_id"] : ["uid", "username"],
    defaultFilters: isTreeMode ? [] : getDefaultFilters(),
    validateFilter: isTreeMode ? () => true : defaultValidateFilter,
    cleanDelay: extendedViewCleanDelay
  });
  const { options } = useAgentAutocompleteOptions({
    agentProfiles,
    isTreeMode,
    displayUid: searchBy === "uid"
  });
  function getDefaultFilters() {
    const filters = [];
    if (onlyMasterAgents) {
      filters.push({ key: "is_master_agent", value: "true" });
    }
    if (defaultPlayerId) {
      filters.push({ key: "referrer_agent_id", value: defaultPlayerId });
    }
    if (value) {
      filters.push({ key: "uid", value });
    }
    return filters;
  }
  function defaultValidateFilter(filter) {
    return getNonEmptyValueValidator("uid")(filter) || getNonEmptyValueValidator("username")(filter) || getNonEmptyValueValidator("referrer_agent_id")(filter) || getNonEmptyValueValidator("uidPartial")(filter);
  }
  function getSelectedValue() {
    const optionValue = value?.toString();
    return optionValue;
  }
  function handleAutocompleteFilterChange(value2) {
    if (onInputChange) {
      onInputChange(value2);
    }
    handleFilterChange([
      { key: "uid", value: null },
      { key: "uidPartial", value: searchBy === "uid" ? value2 : null },
      { key: "username", value: searchBy === "username" ? value2 : null }
    ]);
  }
  const autocompleteComponentMap = {
    default: Autocomplete,
    tree: TreeAutocomplete,
    inline: InlineAutocomplete
  };
  const AutocompleteComponent = autocompleteComponentMap[mode];
  const selectedValue = getSelectedValue();
  return /* @__PURE__ */ React.createElement(
    AutocompleteComponent,
    {
      value: selectedValue,
      options,
      onValueChange: (option) => {
        onChange(option?.value ?? "", option?.label ?? "");
      },
      onFilterChange: handleAutocompleteFilterChange,
      placeholder: localized.agentAutocompletePlaceholder,
      emptyPlaceholder: localized.agentAutocompleteEmptyPlaceholder,
      allowEmptyValue: true,
      listContainerClassName,
      mode: "server"
    }
  );
}
export {
  AgentAutocomplete
};
//# sourceMappingURL=AgentAutocomplete.js.map
